/* 디자인 셀렉트 박스 */
import VueMonthlyPicker from 'vue-monthly-picker';
import SelectForm from '@/components/SelectForm.vue';
import SelectFormSearch from '@/components/SelectFormSearch.vue';
import SelectCheckForm from '@/components/SelectCheckForm.vue';
import CheckForm from '@/components/CheckForm.vue';
import SingleCalendar from '@/components/SingleCalendar.vue';
import ScheduleCalendar from '@/components/ScheduleCalendar.vue';
import TimeSelect from '@/components/TimeSelect.vue';
import Breadcrumb from '@/components/Breadcrumb.vue';
import SelectType from '@/components/SelectType.vue';
import TopSearch from '@/components/TopSearch.vue';
import LoadingSpinner from '@/components/LoadingSpinner';
import PaymentInfo from '@/components/PaymentInfo';
import PeriodPop from '@/components/PeriodPop';
import DaumPostCode from '@/components/DaumPostCode';
import GroupReserveTable from '@/components/GroupReserveTable';
import Popup from '@/components/Popup';
import TouchHeader from '@/components/TouchHeader';
import TouchFooter from '@/components/TouchFooter';

export default {
    SelectForm,
    SelectFormSearch,
    CheckForm,
    SingleCalendar,
    ScheduleCalendar,
    TimeSelect,
    VueMonthlyPicker,
    Breadcrumb,
    SelectType,
    TopSearch,
    SelectCheckForm,
    LoadingSpinner,
    PaymentInfo,
    PeriodPop,
    DaumPostCode,
    GroupReserveTable,
    Popup,
    TouchHeader,
    TouchFooter,
};
